var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.948 11.112C18.511 7.67 15.563 5 12.004 5C9.24803 5 6.85403 6.611 5.76103 9.15C3.61303 9.792 2.00403 11.82 2.00403 14C2.00403 16.757 4.24703 19 7.00403 19H8.00403V17H7.00403C5.35003 17 4.00403 15.654 4.00403 14C4.00403 12.596 5.20303 11.243 6.67703 10.984L7.25803 10.882L7.45003 10.324C8.15303 8.273 9.89803 7 12.004 7C14.761 7 17.004 9.243 17.004 12V13H18.004C19.107 13 20.004 13.897 20.004 15C20.004 16.103 19.107 17 18.004 17H16.004V19H18.004C20.21 19 22.004 17.206 22.004 15C22.0028 14.1035 21.7011 13.2333 21.1471 12.5285C20.5932 11.8237 19.8189 11.3249 18.948 11.112Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.004 14V10H11.004V14H8.00403L12.004 19L16.004 14H13.004Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_download.f0e9e4ff08676a8a0c29e1b31d821213.svg";
export { ForwardRef as ReactComponent };